import React from "react";
import * as Icon from "react-feather";

export const SidebarData = [
  {
    label: "Main",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Main",
    submenuItems: [
      {
        label: "Dashboard",
        link: "/dashboard",
        icon: <Icon.Grid />,
        showSubRoute: false,
        submenu: false,
      },
    ],
  },

  {
    label: "Masters",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Masters",
    submenuItems: [
      {
        label: "Patients",
        link: "/patients",
        icon: <Icon.Users />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Procedures",
        link: "/procedures",
        icon: <Icon.Clipboard />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Doctors",
        link: "/doctors",
        icon: <Icon.UserCheck />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Products",
        link: "/products",
        icon: <Icon.Box />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Suppliers",
        link: "/suppliers",
        icon: <Icon.Truck />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Account Heads",
        link: "/account-heads",
        icon: <Icon.Book />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Tooth",
        link: "/tooth",
        icon: <Icon.Circle />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Shade",
        link: "/shades",
        icon: <Icon.Droplet />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Work",
        link: "/work",
        icon: <Icon.Tool />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Bank",
        link: "/banks",
        icon: <Icon.Home />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Cash",
        link: "/cash",
        icon: <Icon.DollarSign />,
        showSubRoute: false,
        submenu: false,
      },
    ],
  },

  {
    label: "Appointments",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Appointments",
    submenuItems: [
      {
        label: "Appointment Calendar",
        link: "/appointments",
        icon: <Icon.Calendar />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Appointment List",
        link: "/appointment-list",
        icon: <Icon.List />,
        showSubRoute: false,
        submenu: false,
      },
    ],
  },

  {
    label: "Billing",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Billing",
    submenuItems: [
      {
        label: "Invoices",
        link: "/invoices",
        icon: <Icon.FileText />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "New Invoice",
        link: "/invoices/new",
        icon: <Icon.PlusSquare />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Medicine Bills",
        link: "/medicine-bills",
        icon: <Icon.Package />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "New Medicine Bill",
        link: "/medicine-bills/new",
        icon: <Icon.PlusSquare />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Bill wise Receipt",
        link: "/invoices/bill-wise-receipt",
        icon: <Icon.CheckSquare />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Treatment Quotation",
        link: "/quotations",
        icon: <Icon.FileMinus />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "New Quotation",
        link: "/quotations/new",
        icon: <Icon.PlusSquare />,
        showSubRoute: false,
        submenu: false,
      },
    ],
  },

  {
    label: "Purchases",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Purchases",
    submenuItems: [
      {
        label: "Purchase List",
        link: "/purchases",
        icon: <Icon.ShoppingBag />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Purchase Return",
        link: "/purchase-returns",
        icon: <Icon.RefreshCw />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Opening Stock",
        link: "/opening-stock",
        icon: <Icon.Archive />,
        showSubRoute: false,
        submenu: false,
      },
    ],
  },

  {
    label: "Stock",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Stock",
    submenuItems: [
      {
        label: "Current Stock",
        link: "/stock",
        icon: <Icon.Package />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Stock Adjustment",
        link: "/stock-adjustment",
        icon: <Icon.Sliders />,
        showSubRoute: false,
        submenu: false,
      },
    ],
  },

  {
    label: "Finance",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Finance",
    submenuItems: [
      {
        label: "Expenses",
        link: "/expenses",
        icon: <Icon.CreditCard />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Additional Income",
        link: "/income",
        icon: <Icon.TrendingUp />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Journal Entry",
        link: "/journal",
        icon: <Icon.BookOpen />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Supplier Advance",
        link: "/supplier-advance",
        icon: <Icon.DollarSign />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Supplier Payments",
        link: "/supplier-payments",
        icon: <Icon.CheckSquare />,
        showSubRoute: false,
        submenu: false,
      },
    ],
  },

  {
    label: "Reports",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Reports",
    submenuItems: [
      {
        label: "Daily Report",
        link: "/reports/daily",
        icon: <Icon.Sun />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Appointment Report",
        link: "/reports/appointments",
        icon: <Icon.Calendar />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Sales Report",
        link: "/reports/sales",
        icon: <Icon.BarChart2 />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Receipt Report",
        link: "/reports/payments",
        icon: <Icon.CreditCard />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Purchase Report",
        link: "/reports/purchases",
        icon: <Icon.ShoppingBag />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Expense Report",
        link: "/reports/expenses",
        icon: <Icon.FileText />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Bank Report",
        link: "/reports/bank",
        icon: <Icon.Home />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Cash Report",
        link: "/reports/cash",
        icon: <Icon.DollarSign />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Stock Report",
        link: "/reports/stock",
        icon: <Icon.Package />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Stock Movement",
        link: "/reports/stock-movement",
        icon: <Icon.Activity />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Patient History",
        link: "/reports/patient-history",
        icon: <Icon.Clipboard />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Customer Statement",
        link: "/reports/customer-statement",
        icon: <Icon.User />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Supplier Statement",
        link: "/reports/supplier-statement",
        icon: <Icon.Truck />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Receivables",
        link: "/reports/receivables",
        icon: <Icon.ArrowDownCircle />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Payables",
        link: "/reports/payables",
        icon: <Icon.ArrowUpCircle />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "MIS Report",
        link: "/reports/mis",
        icon: <Icon.PieChart />,
        showSubRoute: false,
        submenu: false,
      },
    ],
  },

  {
    label: "Settings",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Settings",
    submenuItems: [
      {
        label: "Users",
        link: "/users",
        icon: <Icon.UserCheck />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Roles & Permissions",
        link: "/roles-permissions",
        icon: <Icon.Shield />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Audit Log",
        link: "/audit-log",
        icon: <Icon.Clock />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Logout",
        link: "/logout",
        icon: <Icon.LogOut />,
        showSubRoute: false,
        submenu: false,
      },
    ],
  },
];
